<template>
  <Popup  :visible="visible" 
  :title="client ? 'Modifier le client' : 'Ajouter un client'"
  :add="!client"
  :addDisabled="false"
  @close="$emit('close')"
  @add="$emit('close'); $emit('add', editableClient)"
  @update="saveClient"
  @delete="$emit('delete', client.id)"
  >
  
  <!-- Contacts -->
  <div class="flex gap-4">
    <div class="flex flex-col gap-4 w-full">
      <!-- <span class="text-gray-500 text-sm text-left">Contact</span> -->
      <div class="flex gap-2">
        <!-- Nom -->
        <div class="relative w-full">
          <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
            Nom
          </span>
          <input type="text" 
            v-model="editableClient.contacts[0].lastName" placeholder="Dupont" 
            class="w-full basicInput"
            :required="!showDelete"
            ref="focusInput"
          >
        </div>
        
        <!-- Prénom -->
        <div class="relative w-full">
          <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
            Prénom
          </span>
          <input type="text" 
            v-model="editableClient.contacts[0].firstName" placeholder="Jean" 
            class="w-full basicInput"
          >
        </div>
      </div>
      
      <!-- Email -->
      <div class="relative w-full">
        <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
          Email
        </span>
        <input type="text" 
          v-model="editableClient.contacts[0].email" placeholder="dupont.jean@mail.com" 
          class="w-full basicInput"
        >
      </div>

      <div class="flex gap-2">
        <!-- Téléphone 1 -->
        <div class="relative w-full">
          <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
            Téléphone 1
          </span>
          <input type="text" 
            v-model="editableClient.contacts[0].phone1" placeholder="06 89 01 89 30" 
            class="w-full basicInput"
          >
        </div>

        <!-- Téléphone 2 -->
        <div class="relative w-full">
          <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
            Téléphone 2
          </span>
          <input type="text" 
            v-model="editableClient.contacts[0].phone2" placeholder="09 78 02 78 45" 
            class="w-full basicInput"
          >
        </div>
      </div>
    </div>
  </div>
  
  <div class="border border-gray-300"></div>

  <div class="flex flex-col gap-4 w-full">
    <!-- Adresse -->
    <div class="relative w-full">
      <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
        Adresse de facturation
      </span>
      <input type="text" 
      v-model="editableClient.adress" placeholder="15 rue du puit" 
      class="w-full basicInput"
      >
    </div>
    
    
    <div class="flex gap-2">
      <!-- Ville -->
      <div class="relative w-3/5">
        <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
          Ville
        </span>
        <input type="text" 
        v-model="editableClient.city" placeholder="Paris" 
        class="w-full basicInput"
        >
      </div>
      
      <!-- Code postal -->
      <div class="relative w-2/5">
        <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
          Code postal
        </span>
        <input type="text" 
        v-model="editableClient.postalCode" placeholder="68400" 
        class="w-full basicInput"
        >
      </div>
    </div>
  </div>

</Popup>
</template>


<script>
import Popup from '@/components/Popups/Popup.vue';

import { updateClient } from '@/services/clientService';

export default {
  props:['client', 'visible'],
  components: {
    Popup,
  },
  data() {
    return {
      editableClient: this.client ? JSON.parse(JSON.stringify(this.client)) : this.createEmptyClient(),
      openedContactIndex: 0
    };
  },
  methods: {
    createEmptyClient() {
      return {
        contacts: [this.createEmptyContact(), this.createEmptyContact()],
        adress: '',
        city: '',
        postalCode: ''
      };
    },
    createEmptyContact() {
      return {
        firstName: '',
        lastName: '',
        email: '',
        phone1: '',
        phone2: ''
      };
    },
    async saveClient(){
      Object.assign(this.client, this.editableClient);
      await updateClient(this.client);
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.focusInput && this.$refs.focusInput.focus();
        });
        // Deep copy
        this.editableClient = this.client ? JSON.parse(JSON.stringify(this.client)) : this.createEmptyClient();
        // Ajoute un deuxième contact vide si besoin
        if (this.editableClient.contacts.length < 2) {
          this.editableClient.contacts.push(this.createEmptyContact());
        }
      }
    }
  }
};
</script>